import React from 'react';

const AgendaAddEvent = () => (
	<p className="agenda-add-event"><a rel="noopener noreferrer" className="btn btn-primary btn-lg btn-pink-3" href="https://openagenda.com/roubaix/signup?redirect=aHR0cHM6Ly9vcGVuYWdlbmRhLmNvbS9yb3ViYWl4L2FkZGV2ZW50" target="_blank">Proposer un évènement</a></p>
)

export default AgendaAddEvent;
